module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/feed-0609ae8e8a2416d34ebba3417b878c3f.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/feed.svg
// module id = Wugz
// module chunks = 24